import React, { Component } from "react";
import VMasker from "vanilla-masker";
import PropTypes from "prop-types";
import Button from "./../button/button";

// Define timeout
let timeout;

class InputSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || "",
			id: props.id || `input${parseInt(Math.random() * 1000)}`
		};

		this.debounceMethod = this.debounceMethod.bind(this);
		this.prepareProps = this.prepareProps.bind(this);
		this.inputHandler = this.inputHandler.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = this.prepareProps(this.props);
	}

	prepareProps(props) {
		let customProps = { ...props }; // babeljs converts to Object.assign, then polyfills.
		delete customProps.onChange;
		delete customProps.onChangeEvent;
		delete customProps.label;
		delete customProps.tooltip;
		delete customProps.tooltipDirection;
		delete customProps.className;
		delete customProps.value;
		delete customProps.errorMessage;
		delete customProps.hasError;
		delete customProps.errorProps;
		delete customProps.children;
		delete customProps.type;
		delete customProps.helpBlock;
		delete customProps.onSearch;
		delete customProps.isDisabled;
		delete customProps.inputMode;
		delete customProps.pattern;

		let value = props.value;
		let type = props.type;

		return { customProps, value, type };
	}

	componentDidMount() {
		this.setInputsMask();
	}

	componentDidUpdate() {
		this.setInputsMask();
	}

	componentWillReceiveProps(nextProps) {
		this.setState(this.prepareProps(nextProps));
	}

	debounceMethod(event) {
		const value = event.target.value;

		event.preventDefault();

		clearTimeout(timeout);
		timeout = setTimeout(() => {
			this.props.onChange(value);
		}, this.props.debounce);
	}

	handleChange(event) {
		event.preventDefault();

		if (this.props.debounce) {
			this.debounceMethod(event);
		}

		const { maskpattern, onChange } = this.props;

		let value = event.target.value;

		event.persist(); // fixes issue #23

		if (maskpattern) {
			this.inputHandler(maskpattern, 14, event, onChange);
		} else {
			this.setState({ value });

			if (!this.props.debounce) {
				if (onChange) {
					onChange(value);
				}
			} else {
				this.props.onChange({ value, inTimeOut: true });
			}
		}
	}

	inputHandler(masks, max, event, callback) {
		if (!Array.isArray(masks)) {
			masks = [masks];
		}
		let c = event.target;
		let v = c.value.replace(/\D/g, "");
		let m = c.value.length > max && masks.length > 1 ? 1 : 0;
		VMasker(c).unMask();
		VMasker(c).maskPattern(masks[m]);
		let value = VMasker.toPattern(v, masks[m]);
		if (callback) {
			callback(v, value);
		}
		this.setState({ value, rawValue: v });
	}

	setInputsMask() {
		const { maskpattern } = this.props;
		const { id } = this.state;

		if (!maskpattern) {
			return;
		}

		var inputDom = document.querySelector(`#${id}`);
		if (inputDom) {
			if (Array.isArray(maskpattern)) {
				VMasker(inputDom).maskPattern(maskpattern[0]);
			} else {
				VMasker(inputDom).maskPattern(maskpattern);
			}
		}
	}

	render() {
		const { id, value, type } = this.state;
		const {
			label,
			className,
			debouncewait,
			tooltip,
			tooltipDirection,
			tooltipColor,
			errorMessage,
			name,
			helpBlock,
			hasError,
			isDisabled,
			inputMode,
			pattern
		} = this.props;

		const styles = ["form-control", "input-component__input", className].join(" ");

		return (
			<div className="form-group input-component">
				{label && (
					<div className="input-component__label-container">
						<label
							id={`${name ? `${name}-label` : ""}`}
							className={`input-component__label-container--label ${
								(errorMessage !== undefined && errorMessage) || hasError
									? "input-component--invalid-input-label"
									: ""
							}`}
						>
							<span className="input-component__label__span">{label}</span>
						</label>
						{tooltip ? (
							<i
								className={`input-component__label-container--tooltip tooltip ${tooltipColor ||
									"gray"}`}
								data-tooltip={tooltip}
								data-flow={tooltipDirection || "up"}
							>
								?
							</i>
						) : null}
					</div>
				)}
				<div className="input-component__container-field-and-messages">
					<input
						id={id}
						value={value}
						className={`${styles} ${
							(errorMessage != undefined && errorMessage) || hasError ? "input-invalid" : ""
						}`}
						onChange={this.handleChange}
						title={label}
						type={type || "text"}
						pattern={pattern}
						inputMode={inputMode}
						{...this.state.customProps}
					/>
					{this.props.children}
					{!errorMessage &&
						helpBlock && (
							<span className="pull-right help-block">
								<small>{helpBlock}</small>
							</span>
						)}
					{errorMessage != undefined &&
						errorMessage && (
							<p
								className="text-right text-invalid"
								dangerouslySetInnerHTML={{ __html: errorMessage }}
							/>
						)}
					{!this.props.children && (
						<a onClick={() => this.props.onSearch()}>
							<i className={`icon-search icon-search--${isDisabled ? "disabled" : "active"} form-control-feedback input-component__container-field-and-messages--icon`} />
						</a>
					)}
				</div>
			</div>
		);
	}
}

InputSearch.propTypes = {
	onChange: PropTypes.func,
	debouncewait: PropTypes.func,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	value: PropTypes.string,
	id: PropTypes.string,
	errorMessage: PropTypes.string,
	hasError: PropTypes.bool,
	maskpattern: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	debounce: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	helpBlock: PropTypes.string,
	onSearch: PropTypes.func,
	isDisabled: PropTypes.bool,
	inputMode: PropTypes.string,
	pattern: PropTypes.string
};

InputSearch.defaultProps = {
	onChange: function(maskValue, value, event) {
		/*no-op*/
	},
	onChangeEvent: function(event, maskValue, value) {
		/*no-op*/
	},
	value: "",
	pattern: "",
	inputMode: "text"
};

export default InputSearch;
